import MuiTabs, { type TabsProps } from '@mui/material/Tabs'
import MuiTab, { type TabProps } from '@mui/material/Tab'
import { styled } from '@mui/material'

const Tabs = styled((props: TabsProps) => (
  <MuiTabs {...props} slotProps={{ indicator: { children: <span className='MuiTabs-indicatorSpan' /> } }} />
))(({ theme }) => ({
  '& .MuiTabs-indicator': {
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    transition: 'none',
  },
  '& .MuiTabs-list': {
    gap: theme.spacing(1.75),
  },
}))

const Tab = styled((props: TabProps) => <MuiTab {...props} />)(({ theme }) => ({
  paddingTop: theme.spacing(1.75),
  paddingBottom: theme.spacing(-0.3),
  alignItems: 'flex-start',
  flexDirection: 'row',
  zIndex: 1,
  ...theme.typography.tab,
  borderRadius: theme.shape.borderRadius,
  border: theme.borders.n100,
  minHeight: 'auto !important',
  '&.Mui-selected': {
    color: theme.palette.common.white,
  },
  '>.MuiSvgIcon-root': {
    marginTop: theme.spacing(-0.3),
  },
}))

export { Tabs, Tab }
